export const domain = "analytics.rezonence.com";
